import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Booststudent() {
  return (
    <section className="boost-student p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <h2 style={{ color: "#111322" }}>
              A unified platform that{" "}
              <span style={{ color: "#565CCF" }}>
                boosted student retention
              </span>{" "}
              by 150%
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Schology bridges the gap between schools, students, and parents,
              bringing everyone together in a unified, digital ecosystem.
            </p>
            <h5 style={{ color: "#111322" }}>
              Ready to Boost Engagement and Retention?
            </h5>
            <Link
              to="/contact"
              className="border_btn schology-case-btn"
              aria-label="TekRevol Contact"
            >
              Let’s Talk Schology
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Booststudent;
